function Footer() {
  return (
    <div className="footer">
      <p>2026 SuDONKu. Built for CS5610.</p>
    </div>
  );
}

export default Footer;